import { type FormAutocompleteProps, FormAutocomplete } from '@mfw/forms';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import Typography from '@mui/material/Typography';
import { type ListProps } from '@mfw/components';
import React from 'react';

import { useAddressContext } from '../FormAddressContext';
import './FormCountry.scss';

export interface FormCountryProps extends Omit<
  FormAutocompleteProps,
  'options' | 'total'
> {
  readOnly?: boolean;
}

export const FormCountry = ({
  name,
  readOnly,
  withoutDeselect = true,
  ...props
}: FormCountryProps) => {
  const {
    countries,
    defaultCountry,
    fetchNextPage,
    setSearchTerm,
    totalCountries,
  } = useAddressContext();

  const options = React.useMemo(() => {
    return [
      ...(countries || []),
      ...(defaultCountry ? [defaultCountry] : []),
    ]?.map((country) => ({
      ...country,
      content: ({ onClick }) => (
        <div
          className="Mfw-FormCountry-item"
          key={country.value}
          onClick={onClick}
        >
          <div className="Mfw-FormCountry-flag">
            {getUnicodeFlagIcon(country.value)}
          </div>
          <Typography component="p">
            {country.label} ({country.value}) +{country.dialCode}
          </Typography>
        </div>
      ),
    })) as ListProps['items'];
  }, [countries, defaultCountry]);

  return (
    <FormAutocomplete
      {...props}
      onSearch={async (term) => setSearchTerm(term)}
      onIntersection={async () => fetchNextPage()}
      total={totalCountries}
      readOnly={readOnly}
      options={options}
      withoutDeselect={withoutDeselect}
      name={name}
    />
  );
};

export default FormCountry;
